// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"605":"b0814970","707":"a5de058c","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};